import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class CategoryMetaService extends BaseService {
    static url = "metas";
    static apis = {
        that: this,
        getFilteredCategoryMetas: function() {
            return this.that.url + "/category-metas";
        },

        getFilteredCategoryMetaTrans: function() {
            return this.that.url + "/category-meta-trans";
        },

        getFilteredCategoryMetasByName: function() {
            return this.that.url + "/category-metas-name";
        },

        getFilteredCategoryMetaTransByName: function() {
            return this.that.url + "/category-meta-trans-name";
        },
    };

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("metas");
    }

    filteredCategoryMetas(ids) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: CategoryMetaService.apis.getFilteredCategoryMetas(),
                    params: { Ids: ids },
                    method: "GET",
                    authorization: false,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    filteredCategoryMetaTrans(ids) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: CategoryMetaService.apis.getFilteredCategoryMetaTrans,
                    params: { Ids: ids },
                    method: "GET",
                    authorization: false,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
    
    filteredCategoryMetasByName(name) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: CategoryMetaService.apis.getFilteredCategoryMetasByName,
                    params: { categoryName: name },
                    method: "GET",
                    authorization: false,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    filteredCategoryMetaTransByName(name) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: CategoryMetaService.apis.getFilteredCategoryMetaTransByName,
                    params: { categoryName: name },
                    method: "GET",
                    authorization: false,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }


}

export default CategoryMetaService;